import modalStyle from './modalStyle.module.css';
import React, {useContext, useEffect, useState} from 'react';
import {Context} from "../../Map/Context";
import {URL_FOR_FILES, subjectNames} from "../../../config/config";
import axios from "axios";
import {disableMapDragging, enableMapDragging} from "../../Map/MapEvents/MapEvents";
import dayjs from "dayjs";
import {SetModalTimeDecorator} from "./SetModalTimeDecorator";

export function ModalReportPDF ({active, setActive, map}){

    const [context, setContext] = useContext(Context)
    const [pdfDateTime,setPdfDateTime] = useState(dayjs(new Date()).format("YYYY-MM-DDTHH:mm"))
    const [pdfSubjectTag,setPdfSubjectTag] = useState()
    const [cloudShielding,setCloudShielding] = useState()
    const [readyToTheNextPage,setReadyToTheNextPage] = useState(false)
    const [getParams,setGetParams] = useState();

    const URL = `${URL_FOR_FILES.URL_PDF}?date_time=${pdfDateTime}&cloud_shielding=${cloudShielding}&subject_tag=${pdfSubjectTag}`

    useEffect(() => {
        SetModalTimeDecorator(context,setPdfDateTime)
    },[context])

    useEffect(() => {
        setReadyToTheNextPage(false)
    },[cloudShielding, pdfSubjectTag, pdfDateTime])

    const checkStates = async () => {
        if(!pdfDateTime || !pdfSubjectTag || !cloudShielding){
            alert("Проверьте введенные данные")
            return false
        }

        try {
            const response = await axios.get(URL)
            if(response.data.file_info){
                alert(`Error: ${response.data.file_info}\nОшибка: нет данных по вашему запросу`)
                setReadyToTheNextPage(false)
            } else if(response.data.fields_error){
                setReadyToTheNextPage(false)
            } else if(response.data){
                setGetParams({token: response.data.token, uuid: response.data.uuid})
                setReadyToTheNextPage(true)
            }
        } catch (e) {
            alert("Данных по вашему запросу не найдено")
            setReadyToTheNextPage(false)
        }
    }

    const toThePdf = () => {
        window.open(`${URL}&token=${getParams.token}&uuid=${getParams.uuid}`, "_blank")
    }

    return <>
        <div className={active ? `${modalStyle.modal} ${modalStyle.modal_active}` : modalStyle.modal}
             onClick={()=> setActive(false)}
             onMouseDown={()=> disableMapDragging(map)}
             onMouseUp={() => enableMapDragging(map)}
        >
            <div className={active ? `${modalStyle.modal_content} ${modalStyle.modal_content_active}` : modalStyle.modal_content}
                 onClick={(e) => e.stopPropagation()}>
                
                <div className={modalStyle.modal_div}>
                    <label className={modalStyle.modal_label}>Дата и время</label>
                    <input type={"datetime-local"} id={'dateTime'} max={dayjs(Date.now()).format("YYYY-MM-DDTHH:mm")} className={modalStyle.modal_input}
                           value={pdfDateTime}
                           onChange={(e) => {
                               setPdfDateTime(e.target.value)
                               setReadyToTheNextPage(false)
                           }}/>
                </div>

                <div className={modalStyle.modal_div}>
                    <label className={modalStyle.modal_label}>Район обнаружения ТВВ</label>
                    <input list={"browsers"} type={"text"} className={modalStyle.modal_input}
                           placeholder={'Введите название и выберите регион'}
                           value={pdfSubjectTag}
                           onChange={(e) => {
                               setPdfSubjectTag(e.target.value)
                               setReadyToTheNextPage(false)
                           }}/>
                    <datalist id="browsers">
                        {subjectNames.map((settlement,index)=>(<option key={index} value={settlement.tag}>{settlement.name}</option>))}
                    </datalist>
                </div>

                <div className={modalStyle.modal_div}>
                    <label className={modalStyle.modal_label}>Экранирование облачностью</label>
                    <input type={"number"} className={modalStyle.modal_input}
                           value={cloudShielding}
                           onChange={(e) => {
                               setCloudShielding(e.target.value)
                               setReadyToTheNextPage(false)
                           }}/>
                </div>

                {readyToTheNextPage ?
                    <button className={`${modalStyle.modal_button} ${modalStyle.modal_button_open}`} onClick={() => toThePdf()} >Открыть отчет</button>
                    :
                    <button className={modalStyle.modal_button} onClick={() => checkStates()}>Проверить наличие данных</button>
                }
            </div>
        </div>
    </>
}
